import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link, useNavigate, useParams } from "react-router-dom";
import Header from "../layouts/Header";
import Navbar from "../layouts/Navbar";
import ImageCropper from "../crop_image/ImageCropper";
import Swal from "sweetalert2";
import "./Dcare.css";

function DcareEdit() {
    const navigate = useNavigate();
    const { id } = useParams(); // Assuming you're passing the id of the poliklinik to edit via the route parameters

    const [formValue, setFormValue] = useState({
        cover: null,
        foto_1: null,
        foto_2: null,
        foto_3: null,
        foto_4: null,
        foto_5: null,
        foto_6: null,
        penjelasan: "",
        link_web: "",
        link_ig: "",
        link_yt: "",
    });

    const [preview, setPreview] = useState({
        cover: null,
        foto_1: null,
        foto_2: null,
        foto_3: null,
        foto_4: null,
        foto_5: null,
        foto_6: null,
    });

    const [cropData, setCropData] = useState({
        isOpen: false,
        imageSrc: null,
        imageType: "",
    });

    const [croppedImage, setCroppedImage] = useState(null);
    const [selectedFiles, setSelectedFiles] = useState({
        cover: null,
        foto_1: null,
        foto_2: null,
        foto_3: null,
        foto_4: null,
        foto_5: null,
        foto_6: null,
    });

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_URL}/dcare/readDcare/${id}`);
                const data = response.data;
                setFormValue({
                    cover: null,
                    foto_1: null,
                    foto_2: null,
                    foto_3: null,
                    foto_4: null,
                    foto_5: null,
                    foto_6: null,
                    penjelasan: data.penjelasan,
                    link_web: data.link_web,
                    link_ig: data.link_ig,
                    link_yt: data.link_yt,
                });
                setPreview({
                    cover: data.cover,
                    foto_1: data.foto_1,
                    foto_2: data.foto_2,
                    foto_3: data.foto_3,
                    foto_4: data.foto_4,
                    foto_5: data.foto_5,
                    foto_6: data.foto_6,
                });
            } catch (error) {
                Swal.fire({
                    title: "Error",
                    text: "Gagal memuat data",
                    icon: "error",
                });
            }
        };

        fetchData();
    }, [id]);

    const openCropper = (file, imageType) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            setCropData({
                isOpen: true,
                imageSrc: reader.result,
                imageType,
            });
        };
    };

    const closeCropper = () => {
        setCropData({
            isOpen: false,
            imageSrc: null,
            imageType: "",
        });
        setCroppedImage(null);
    };

    const applyCrop = () => {
        if (croppedImage instanceof Blob) {
            const blobUrl = URL.createObjectURL(croppedImage);
            setSelectedFiles({
                ...selectedFiles,
                [cropData.imageType]: croppedImage,
            });
            setPreview({
                ...preview,
                [cropData.imageType]: blobUrl,
            });
        } else {
            console.error("Cropped image is not a Blob:", croppedImage);
        }
        closeCropper();
    };

    const handleChange = (event) => {
        const { name, value, files } = event.target;
        if (files && files.length > 0) {
            const file = files[0];
            openCropper(file, name);
        } else {
            setFormValue({
                ...formValue,
                [name]: value,
            });
        }
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        const {
            cover,
            foto_1,
            foto_2,
            foto_3,
            foto_4,
            foto_5,
            foto_6,
            penjelasan,
            link_web,
            link_ig,
            link_yt,
        } = formValue;

        // Check for required fields
        if (!link_web || !penjelasan || !link_ig || !link_yt) {
            Swal.fire({
                title: "Error",
                text: "Semua field harus diisi",
                icon: "error",
            });
            return;
        }

        // Create a FormData instance
        const FormDataInput = new FormData();
        if (selectedFiles.cover) FormDataInput.append("cover", selectedFiles.cover);
        if (selectedFiles.foto_1) FormDataInput.append("foto_1", selectedFiles.foto_1);
        if (selectedFiles.foto_2) FormDataInput.append("foto_2", selectedFiles.foto_2);
        if (selectedFiles.foto_3) FormDataInput.append("foto_3", selectedFiles.foto_3);
        if (selectedFiles.foto_4) FormDataInput.append("foto_4", selectedFiles.foto_4);
        if (selectedFiles.foto_5) FormDataInput.append("foto_5", selectedFiles.foto_5);
        if (selectedFiles.foto_6) FormDataInput.append("foto_6", selectedFiles.foto_6);
        FormDataInput.append("link_web", link_web);
        FormDataInput.append("penjelasan", penjelasan);
        FormDataInput.append("link_ig", link_ig);
        FormDataInput.append("link_yt", link_yt);

        try {
            const token = localStorage.getItem("token");
            if (!token) {
                navigate("/");
                return;
            }

            // Set token in axios headers
            axios.interceptors.request.use(
                (config) => {
                    config.headers.authorization = token;
                    return config;
                },
                (error) => {
                    return Promise.reject(error);
                }
            );

            // Make axios PUT request
            const response = await axios.put(
                `${process.env.REACT_APP_API_URL}/dcare/updateDcare/${id}`,
                FormDataInput,
                { headers: { "Content-Type": "multipart/form-data" } }
            );

            Swal.fire({
                title: "Success",
                text: "Data berhasil diperbarui",
                icon: "success",
            });
            navigate("/dcare");
        } catch (error) {
            console.error("Error updating data:", error);
            Swal.fire({
                title: "Error",
                text: "Data gagal diperbarui",
                icon: "error",
            });
        }
    };

    return (
        <div className="wrapper recruitment-main">
            <Header />
            <Navbar />
            <div className="content-wrapper">
                <section className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-6">
                                <h1>Administrasi</h1>
                            </div>
                            <div className="col-sm-6">
                                <ol className="breadcrumb float-sm-right">
                                    <li className="breadcrumb-item text-decoration-none">
                                        <Link className="text-decoration-none" to="/">
                                            Administrasi
                                        </Link>
                                    </li>
                                    <li className="breadcrumb-item active">UT SCHOOL</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="content">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-12">
                                <div className="card">
                                    <div className="card-header">
                                        <h3 className="card-title">Edit UT SCHOOL</h3>
                                    </div>
                                    <div className="card-body">
                                        <form onSubmit={handleSubmit}>
                                            <div className="card-body">
                                                <div className="form-group">
                                                    <label>Foto Cover</label>
                                                    <input
                                                        type="file"
                                                        className="form-control"
                                                        name="cover"
                                                        accept="image/*"
                                                        placeholder="Masukkan foto cover"
                                                        onChange={handleChange}
                                                    />
                                                    {preview.cover && (
                                                        <div className="preview-container-program">
                                                            <img
                                                                src={preview.cover}
                                                                alt="Preview"
                                                                className="preview-image-program"
                                                            />
                                                        </div>
                                                    )}
                                                </div>
                                                {Array.from({ length: 6 }, (_, index) => (
                                                    <div
                                                        className="form-group"
                                                        key={`foto_${index + 1}`}
                                                    >
                                                        <label>Foto {index + 1}</label>
                                                        <input
                                                            type="file"
                                                            className="form-control"
                                                            name={`foto_${index + 1}`}
                                                            accept="image/*"
                                                            placeholder={`Masukkan foto ${
                                                                index + 1
                                                            }`}
                                                            onChange={handleChange}
                                                        />
                                                        {preview[`foto_${index + 1}`] && (
                                                            <div className="preview-container-program">
                                                                <img
                                                                    src={
                                                                        preview[`foto_${index + 1}`]
                                                                    }
                                                                    alt={`Preview Foto ${
                                                                        index + 1
                                                                    }`}
                                                                    className="preview-image-program"
                                                                />
                                                            </div>
                                                        )}
                                                    </div>
                                                ))}
                                                <div className="form-group">
                                                    <label>Penjelasan</label>
                                                    <textarea
                                                        className="form-control"
                                                        name="penjelasan"
                                                        value={formValue.penjelasan}
                                                        onChange={handleChange}
                                                        rows="3"
                                                        placeholder="Masukkan penjelasan"
                                                    ></textarea>
                                                </div>
                                                <div className="form-group">
                                                    <label>Link Web</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="link_web"
                                                        value={formValue.link_web}
                                                        onChange={handleChange}
                                                        placeholder="Masukkan link web"
                                                    />
                                                </div>
                                                <div className="form-group">
                                                    <label>Link Instagram</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="link_ig"
                                                        value={formValue.link_ig}
                                                        onChange={handleChange}
                                                        placeholder="Masukkan link Instagram"
                                                    />
                                                </div>
                                                <div className="form-group">
                                                    <label>Link Youtube</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="link_yt"
                                                        value={formValue.link_yt}
                                                        onChange={handleChange}
                                                        placeholder="Masukkan link Youtube"
                                                    />
                                                </div>
                                            </div>
                                            <div className="card-footer">
                                                <button type="submit" className="btn btn-primary">
                                                    Simpan
                                                </button>
                                                <Link to="/dcare" className="btn btn-secondary">
                                                    Kembali
                                                </Link>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
            {cropData.isOpen && (
                <ImageCropper
                    imageSrc={cropData.imageSrc}
                    setCroppedImage={setCroppedImage}
                    onCropComplete={applyCrop}
                    onClose={closeCropper}
                />
            )}
        </div>
    );
}

export default DcareEdit;
